import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';

const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            item: '',
            koin: '',
            reason: '',


        }
    },
    validators: {
        item: function (value) {
            return Validator.value(value)
                .required('상품명을 입력해 주세요.')
        },

        koin: function (value) {
            return Validator.value(value)
                .required('지급코인을 입력해 주세요.')
                .integer('1이상, 10000이하의 숫자만 입력이 가능합니다.')
                .greaterThanOrEqualTo(1, '1이상의 숫자만 입력이 가능합니다.')
                .lessThanOrEqualTo	(10000,'10000이하의 숫자만 입력이 가능합니다.')
        },
        reason: function (value) {
            return Validator.value(value)
                .required('이유를 입력해 주세요.')

        }
    }
}
